import { useEffect, useRef } from 'react';

/**
 * A ref that reads false once the component has unmounted.
 *
 * The tutorial hooks await in a few places — waiting for a step's first target,
 * writing the durable completion flag — and a route change can unmount the
 * container mid-flight, so every post-await continuation checks this before
 * touching state (React warns about state updates on unmounted components).
 */
const useMountedRef = () => {
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  return mountedRef;
};

export default useMountedRef;
